import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import * as Constants from "../../../constants/Constants";
import { AGREEMENT_ICON } from "../../../assets/js/image";
import Cookie from "js-cookie";

export default class Welcome extends Component {
  constructor(props) {
    super(props);
  }

  redirectTo() {
    this.props.history.push("/boarding/vendor");
  }

  render() {
    return (
      <div className="col-md-10 offset-md-1 top-20">
        <Row>
          <Col md={3}>
            <div className="imageContainer">
              <AGREEMENT_ICON
                style="agreementLogo"
                altText={Constants.LOGO_ALT_TEXT}
              />
            </div>
          </Col>
          <Col md={8} className="verticalPipe">
            <Row className="">
              <Col>
                <label className="welcomeUser">
                  {Constants.WELCOME} {Cookie.get("userName")}
                  {Constants.EXCLAMATION}
                </label>
                <label className="welcomeText">
                  {Constants.VERBIAGE_WELCOME_MESSAGE_PART1}
                </label>
                <br />
                <label className="welcomeText">
                  {Constants.VERBIAGE_WELCOME_MESSAGE_PART2}
                </label>
              </Col>
            </Row>
            <Row className="m-top-10">
              <Col md={{ span: 8, offset: 1 }}>
                <span className="circleRed">
                  <label className="mt-xs">{Constants.ONE}</label>
                </span>
                <label className="detailsWelcomePage welcomeLabel">
                  {Constants.VERBIAGE_COMPANY_DETAILS}
                </label>
                <p className="sectionTitleWelcome welcomeHelpText">
                  {Constants.COMPANY_DETAILS_SECTIONS}
                </p>
              </Col>
            </Row>
            <Row className="m-top-10">
              <Col md={{ span: 8, offset: 1 }}>
                <span className="circleRed">
                  <label className="mt-xs">{Constants.TWO}</label>
                </span>
                <label className="detailsWelcomePage welcomeLabel">
                  {Constants.VERBIAGE_PRE_BOARDING}
                </label>
                <p className="sectionTitleWelcome welcomeHelpText">
                  {Constants.PREBOARDING_SECTIONS}
                </p>
              </Col>
            </Row>
            <Row className="m-top-10">
              <Col md={{ span: 8, offset: 1 }}>
                <span className="circleRed">
                  <label className="mt-xs">{Constants.THREE}</label>
                </span>
                <label className="detailsWelcomePage welcomeLabel">
                  {Constants.VERBIAGE_INTEGRATION}
                </label>
                <p className="sectionTitleWelcome welcomeHelpText">
                  {Constants.INTEGRATION_SECTIONS}
                </p>
              </Col>
            </Row>

            <Row className="m-top-10">
              <Col md={{ span: 8, offset: 1 }}>
                <span className="circleRed">
                  <label className="mt-xs">{Constants.FOUR}</label>
                </span>
                <label className="detailsWelcomePage welcomeLabel">
                  {Constants.VERBIAGE_PUBLISH}
                </label>
                <p className="sectionTitleWelcome welcomeHelpText">
                  {Constants.PUBLISH_SECTIONS}
                </p>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col md={{ span: 3, offset: 8 }}>
                <button
                  type="submit"
                  className="button-primary-md"
                  id={Constants.WELCOME + "_" + Constants.LETS_GET_STARTED}
                  onClick={() => this.redirectTo()}
                >
                  {Constants.LETS_GET_STARTED}
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
